import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError, finalize } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import type { GetTransferredCaseFieldsQuery } from './get-transferred-case-fields.query';
import type { GetTransferredCaseFieldsResult } from './get-transferred-case-fields.result';

@Injectable({ providedIn: 'root' })
export class GetTransferredCaseFieldsUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(query: GetTransferredCaseFieldsQuery): Observable<GetTransferredCaseFieldsResult> {
    this._state.setLoadingTransferredCaseFields(true);
    this._state.setErrorTransferredCaseFields(null);

    return this._repository.getTransferredCaseFields(query.investigationId).pipe(
      tap((fields) => {
        this._state.setTransferredCaseFields(fields);
      }),
      map((fields) => ({ fields })),
      catchError((error) => {
        const message = error?.error?.message || error?.message || 'Failed to load transferred case fields';
        this._state.setErrorTransferredCaseFields(message);
        this._state.setTransferredCaseFields([]);
        return throwError(() => error);
      }),
      // finalize covers complete, error AND unsubscribe (e.g. the widget's effect tearing down
      // when investigationId changes mid-request), so the loading flag never sticks.
      finalize(() => {
        this._state.setLoadingTransferredCaseFields(false);
      }),
    );
  }
}
